export enum ScanModeType
{
  CameraMode = 1,
  FromImage = 2,
  Manually=3
}
